/* eslint-disable react-hooks/exhaustive-deps */
import { cloneDeep, isEmpty } from "lodash";
import React, { useState, useEffect } from "react";
import { getVacationsHistoriesList, getVacationsHistoriesListDownloads } from "../../../apis/vacation/vacations";
import Filters from "../../../components/Filters";
import PageHeader from "../../../components/PageHeader";
import { ControlTable } from "../../../components/Table";
import useForm from "../../../hooks/useForm";
import { getDay } from "../../../utils/date";
import { downExcelFile } from "../../../utils/download";
import { getParams } from "../../../utils/params";

const ChangeHistory = ({ tabList, activeTab }) => {
  const [fields] = useState([
    { title: "변경일", key: "createdTime" },
    { title: "변경자", key: "employeeIdx", type: 'profile' },
    { title: "대상자", key: "targetEmployeeIdx", type: 'profile' },
    { title: "변경항목", key: "title" },
    {
      title: "변경전",
      key: "orgUsableCount",
      onValue: (value) => {
        return value + "";
      },
    },
    {
      title: "변경후",
      key: "nowUsableCount",
      onValue: (value) => {
        return value + "";
      },
    },
    { title: "사유", key: "description" },
  ]);

  const [filters] = useState([
    {
      title: "조회기간",
      type: "CustomDatePicker",
      key: "range.createdTime",
    },
    {
      title: "대상자",
      type: 'searchEmployees',
      key: "search.employeeIdx",
      isSingle: true,
    },
  ])


  const {
    form,
    setSubmit,
    handleOnChange,
    handleSubmit,
    // LIST 용
    filterSubmit,
    list, setList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
  } = useForm(
    {
      search: {
        employeeIdx: null,
      },
      range: {
        createdTime: [getDay(7), getDay()]
      },
      page: 0,
      limit: 10
    },
  )

  useEffect(() => {
    submit(form);
    setSubmit(submit)
  }, []);

  const submit = (form) => {
    const _form = cloneDeep(form)
    if (!isEmpty(_form.range.createdTime))
    {
      _form.range.createdTime = {
        from: _form.range.createdTime[0],
        to: _form.range.createdTime[1]
      }
    }

    if (!isEmpty(_form.search.employeeIdx))
    {
      _form.search.employeeIdx = _form.search.employeeIdx[0].idx
    }
    setList([])

    setIsLoading(true);
    getVacationsHistoriesList(getParams(_form))
      .then((res) => {
        setIsLoading(false);
        setList(res.data.histories);
        setTotal(res.data.total);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setIsLoading(false));
  };

  const headerButtons = [
    {
      color: "gray-line",
      label: (
        <>
          엑셀다운로드 <i className="mdi mdi-arrow-collapse-down" />
        </>
      ),
      action: () => {
        const _form = cloneDeep(form)
        if (!isEmpty(_form.range.createdTime))
        {
          _form.range.createdTime = {
            from: _form.range.createdTime[0],
            to: _form.range.createdTime[1]
          }
        }

        if (!isEmpty(_form.search.employeeIdx))
        {
          _form.search.employeeIdx = _form.search.employeeIdx[0].idx
        }
        getVacationsHistoriesListDownloads(getParams(_form)).then((res) => {
          downExcelFile(res, '휴가 변경 이력.xlsx')
        })
      }
    },
  ];

  return (
    <>
      <PageHeader
        title={"휴가 부여 현황"}
        tabList={tabList}
        activeTab={activeTab}
        buttons={headerButtons}
      />
      <Filters
        isLoading={isLoading}
        filters={filters}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange}
      />
      <ControlTable
        isLoading={isLoading}
        fields={fields}
        list={list}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        total={total}
        submit={handleSubmit}
      />
    </>
  );
};

export default ChangeHistory;
